// extracted by css-extract-rspack-plugin
export default {"root":"root-m3XskZ","underlay":"underlay-CA_RBh"};